import { Anchor, Card } from '@zenid/web';
import { genericError } from '../../../../styled-system/recipes';

type Props = {
  logout?: boolean;
  error?: string;
};

export function Unauthorized({ logout, error }: Props) {
  const { contentsLayout, contentsInnerLayout, iconLayout, icon, title, messageLayout, message, actionsLayout } =
    genericError();
  return (
    <Card className={contentsLayout}>
      <div className={contentsInnerLayout}>
        <div className={iconLayout}>
          <img
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/seagull_meal.png`}
            className={icon}
            alt="エラーページのアイコン"
          />
        </div>
        <div className={messageLayout}>
          <h1 className={title}>認証エラー</h1>
          <p className={message}>
            {/* error description が 12 文字(例: "ログインに失敗しました。" を超える場合のみ表示 */}
            {error && error.length > 12 ? error : '認証に失敗しました。正しい手順で操作しているか再度ご確認ください。'}
          </p>
        </div>
        <div className={actionsLayout}>
          {logout ? (
            <Anchor variant="button" href="/logout" color="primary" size="l" width={200}>
              ログアウト
            </Anchor>
          ) : (
            <Anchor variant="button" href="/home" color="primary" size="l" width={200}>
              ZEN IDに戻る
            </Anchor>
          )}
        </div>
      </div>
    </Card>
  );
}
